import React, { useState } from 'react';
import cn from 'classnames';

import SwatchImage from 'components/common/SwatchImage';

import css from 'styles/components/common/colorswatches.scss';

const useColorSwatches = props => {
  const [visible, setVisible] = useState(false);
  const [swatchImageId, setSwatchImageId] = useState(false);

  const { relatedStyles, onClick } = props;

  if (!relatedStyles) {
    return { swatchImageId: null, markup: null };
  }

  const setSwatchImage = imageId => {
    setSwatchImageId(imageId);
  };

  const handleVisibility = e => {
    e.preventDefault();
    const eventType = e.type;
    if (!visible && (eventType === 'mouseenter' || eventType === 'touchend')) {
      setVisible(true);
    } else if (visible && (eventType === 'mouseleave' || eventType === 'blur')) {
      setVisible(false);
    }
  };

  const images = [...relatedStyles, props].map((productData, swatchIndex) => <SwatchImage key={productData.styleId} {...productData} setImageId={setSwatchImage} onClick={e => onClick(e, null, swatchIndex)} />);

  const markup = (
    <div className={cn(css.crss, { [css.visible]: visible })}>
      <div className={css.imageWrapper}>
        <ul onMouseLeave={handleVisibility} onBlur={handleVisibility}>{images}</ul>
      </div>
      <button type="button" onMouseEnter={handleVisibility} onTouchEnd={handleVisibility}>{images.length} colors</button>
    </div>
  );

  return { swatchImageId, markup };
};

export default useColorSwatches;
